import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { injectIntl } from 'sb-react-intl'
import { compose } from 'common/helpers'
import cx from 'classnames'

import messages from './messages'
import s from './Countdown.scss'


class Countdown extends Component {

  static propTypes = {
    startDate: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
      PropTypes.number,
    ]).isRequired,
    hours: PropTypes.number.isRequired,
    withColons: PropTypes.bool,
    withDecor: PropTypes.bool,
    className: PropTypes.string,
    hideZeroHours: PropTypes.bool,
    popupName: PropTypes.string,
    /*
      withCloseTimer prop is used when you need your countdown component to fire setClosedPopup
      in a certain amount of time after countdown is finished
      you can use timeLeftForTimer prop to set this amount of time
   */
    withCloseTimer: PropTypes.bool,
    timeLeftForTimer: PropTypes.number,
  }

  static defaultProps = {
    withColons: false,
    withDecor: false,
    hideZeroHours: false,
    withCloseTimer: false,
  }

  initialized = false

  componentDidMount() {
    this.initTimer()
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  componentDidUpdate() {
    const { startDate } = this.props

    if (startDate && !this.initialized) {
      this.initTimer()
    }
  }

  initTimer = () => {
    const { startDate, hours, popupName, withCloseTimer, timeLeftForTimer } = this.props

    if (!startDate) {
      return
    }

    this.initialized = true
    const activeTime = 60 * 60 * hours * 1000

    // TODO ask backend to receive actual server time
    const timeFromStart = Date.now() - new Date(startDate).getTime()

    this.timeLeftForCountdown   = Math.floor(activeTime - timeFromStart)
    this.timeLeftForTimer       = withCloseTimer && timeLeftForTimer ? timeLeftForTimer : this.timeLeftForCountdown

    if (this.timeLeftForTimer > 0) {
      this.timer = setInterval(this.tick, 1000)

      this.tick()
      return
    }

    if (popupName) {
      actions.models.ui.setClosedPopup(popupName)
    }

    this.renderTimer(0, 0, 0)
  }

  getDoubleDigitNumber = (number) => number < 10 ? `0${number}` : number

  tick = () => {
    const { popupName } = this.props

    this.timeLeftForCountdown -= 1000
    this.timeLeftForTimer -= 1000

    if (this.timeLeftForCountdown <= 0) {
      this.renderTimer(0, 0, 0)
    }
    else {
      const hours   = Math.floor((this.timeLeftForCountdown / 60 / 60 / 1000) % 24)
      const mins    = Math.floor((this.timeLeftForCountdown / 60 / 1000) % 60)
      const secs    = Math.floor((this.timeLeftForCountdown / 1000) % 60)

      this.renderTimer(hours, mins, secs)
    }

    if (this.timeLeftForTimer <= 0) {
      clearInterval(this.timer)

      if (popupName) {
        actions.models.ui.setClosedPopup(popupName)
      }
    }
  }

  renderTimer = (hours, mins, secs) => {
    const { intl, withColons, withDecor, hideZeroHours } = this.props

    if (withDecor) {
      const data = [
        {
          title: intl.formatMessage(messages.hours),
          value: hours,
        },
        {
          title: intl.formatMessage(messages.minutes),
          value: this.getDoubleDigitNumber(mins),
        },
        {
          title: intl.formatMessage(messages.seconds),
          value: this.getDoubleDigitNumber(secs),
        },
      ]
        .map(({ title, value }) => (
          `
            <div class="${s.box}">
              <div class="${s.title}">${title}</div>
              <div class="${s.digits}">${value}</div>
            </div>
          `
        ))

      this.node.innerHTML = data.join('')
    }
    else if (withColons) {
      this.node.innerHTML = `${hours}:${this.getDoubleDigitNumber(mins)}:${this.getDoubleDigitNumber(secs)}`
    }
    else {
      const hoursTitle  = intl.formatMessage(messages.hours)
      const minsTitle   = intl.formatMessage(messages.mins)
      const secsTitle   = intl.formatMessage(messages.secs)

      if (!hours && hideZeroHours) {
        this.node.innerHTML = `${mins} ${minsTitle} ${secs} ${secsTitle}`
      }
      else {
        this.node.innerHTML = `${hours} ${hoursTitle} ${mins} ${minsTitle} ${secs} ${secsTitle}`
      }
    }
  }

  render() {
    const { className, withDecor } = this.props

    const countdownClassName = cx(className, {
      [s.countdown]: !withDecor,
      [s.withDecor]: withDecor,
    })

    return (
      <div
        className={countdownClassName}
        ref={(node) => {
          this.node = node
        }}
      />
    )
  }
}


export default compose(
  injectIntl
)(Countdown)
